module.exports = __webpack_public_path__ + "static/media/shop.b52753ad.png";